__turbopack_context__.v({
  "centralText": "SectionDivider-module-scss-module__VCrCyq__centralText",
  "divider": "SectionDivider-module-scss-module__VCrCyq__divider",
  "leftDivider": "SectionDivider-module-scss-module__VCrCyq__leftDivider",
  "rightDivider": "SectionDivider-module-scss-module__VCrCyq__rightDivider",
  "sectionDivider": "SectionDivider-module-scss-module__VCrCyq__sectionDivider",
});
